import { NativeCollabQuery } from '@confluence/native-collab/entry-points/NativeCollabQuery.graphql.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { QueryInteropSupportedResult } from '@confluence/apollo-relay-interop/entry-points/query.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';

export const refetchEditorContent = async (
	contentId: string,
): Promise<QueryInteropSupportedResult<unknown> | undefined> => {
	try {
		return await queryInterop({
			query: NativeCollabQuery,
			context: { single: true },
			fetchPolicy: 'network-only',
			variables: { contentId, status: ['draft', 'current'] }, // For live docs, we need to fetch the current status instead of draft as live docs don't have drafts
		});
	} catch {
		// NOTE: We intentionally swallow any possible error here as this query is only aimed
		// populate the cache with just published content. Should any error occur here after
		// successful publishing the page, the Apollo cache for the query will be invalidated
		// anyway and View Page will fetch the page and handle possible errors.
	}
};
